import { Fragment, useState } from "react";
import { Grid, Play, YouTubeModal } from "components";
import { ArticleInt, ArticleImageInt, ArticleVideoInt } from "interfaces";
import { isDesktop } from "utils/isDesktop";
import styles from "./Article.module.scss";

const VideoItem = (item: ArticleVideoInt) => {
    // const [scrollLocation, _setScrollLocation] = useState(0),
    //   disableScroll = () => {
    //     _setScrollLocation(window.scrollY);
    //     document.body.style.position = "fixed";
    //     document.body.style.top = `0`;
    //     document.body.style.left = `0`;
    //     document.body.style.right = `0`;
    //   };

    // function enableScroll() {
    //   document.body.style.position = "";
    //   document.body.style.top = "";
    //   window.scrollTo(0, scrollLocation || 0);
    //   _setScrollLocation(0);
    // }

    const [open, _setOpen] = useState(false),
      openVideoModal = () => {
        // disableScroll();
        _setOpen(true);
      },
      closeVideoModal = () => {
        // enableScroll();
        _setOpen(false);
      };

    return (
      <Fragment key={item.title}>
        <div className={styles.wrapper}>
          {item.src && (
            <div className={styles.img}>
              <img
                src={item.src}
                width={item.width}
                height={item.height}
                alt={item.title}
                // loading="lazy"
              />
              <Play onClick={openVideoModal} href={item.video.src} />
            </div>
          )}
          <h4 className={`${styles.title} bold`}>{item.title}</h4>
          <p className={styles.body}>{item.body}</p>
          {isDesktop ? (
            <>
              {item.action?.href ? (
                <div
                  className={`${styles.action} ${
                    item.action?.dark && styles.dark
                  }`}
                >
                  <a
                    className={`${styles.link}`}
                    href={item.action.href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={item.action.title}
                  >
                    <p className="bold">{item.action.title}</p>
                  </a>
                </div>
              ) : (
                item.action?.title && (
                  <button
                    className={`${styles.action}`}
                    onClick={openVideoModal}
                    aria-label={item.action.title}
                  >
                    <p className="bold">{item.action.title}</p>
                  </button>
                )
              )}
              <YouTubeModal
                href={item.video.src}
                open={open}
                closeModal={closeVideoModal}
              />
            </>
          ) : (
            item.action?.title && (
              <div
                className={`${styles.action} ${
                  item.action?.dark && styles.dark
                }`}
              >
                <a
                  className={`${styles.link}`}
                  href={item.action.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={item.action.title}
                >
                  <p className="bold">{item.action.title}</p>
                </a>
              </div>
            )
          )}
        </div>
      </Fragment>
    );
  },
  ImageItem = (item: ArticleImageInt) => {
    return (
      <div key={item.title} className={styles.wrapper}>
        {item.src && (
          <div className={styles.img}>
            <img
              src={item.src}
              width={item.width}
              height={item.height}
              alt={item.title}
              // loading="lazy"
            />
          </div>
        )}
        <h4 className={`${styles.title} bold`}>{item.title}</h4>
        <p className={styles.body}>{item.body}</p>
        {item.action && (
          <div className={`${styles.action}`}>
            <a
              className={`${styles.link}`}
              href={item.action.href}
              target="_blank"
              rel="noreferrer"
              aria-label={item.action.title}
            >
              <p className="bold">{item.action.title}</p>
            </a>
          </div>
        )}
        {item.actionTwo && (
          <div className={`${styles.action}`}>
            <a
              className={`${styles.link}`}
              href={item.actionTwo.href}
              target="_blank"
              rel="noreferrer"
              aria-label={item.actionTwo.title}
            >
              <p className="bold">{item.actionTwo.title}</p>
            </a>
          </div>
        )}
      </div>
    );
  };

const Article = ({
  header,
  content,
  bg = "light",
  wgyb,
  threeUp,
}: ArticleInt) => {
  return (
    <section
      className={`${styles["article-block"]} ${styles[bg]} ${
        wgyb ? styles.wgyb : ""
      }`}
    >
      {header && <h2 className={`${styles.header} bold`}>{header}</h2>}
      <Grid className={threeUp ? "three-up" : "two-up"}>
        {content.map((item) => {
          if (item.video) {
            return VideoItem(item as ArticleVideoInt);
          } else {
            return ImageItem(item as ArticleImageInt);
          }
        })}
      </Grid>
    </section>
  );
};

export default Article;
